import Accordion from './components/Accordion';

function initAccordions() {
    Accordion.create('[data-accordion]');
}

function initFilters() {
    const categorySelectBox = document.querySelector('[data-category-select]');
    const industrySelectBox = document.querySelector('[data-industry-select]');
    const selects = document.querySelectorAll('[data-category-select], [data-industry-select]');

    for (const select of selects) {

        select.addEventListener('change', function() {
            filterByCategoryOrIndustry(
                this.getAttribute('data-testimonials-base-url'),
                categorySelectBox.options[categorySelectBox.selectedIndex].value,
                industrySelectBox.options[industrySelectBox.selectedIndex].value
            );
        });
    }
}

function filterByCategoryOrIndustry(basepath, category, industry) {
    const url = `${basepath}/${category}/${industry}`;
    document.location.href = url.replace(/(\/all)+$/,'');
}


document.addEventListener('DOMContentLoaded', () => {
    initAccordions();
    initFilters();
});



// WEBPACK FOOTER //
// ./js/marketing/testimonials.js